import React from "react";
import { Container, Row, Col } from "reactstrap";
import "../../assets/css/privacy-policy.css";
// privacy policy
const PrivacyPolicy = () => {
  return (
    <Container fluid className="privacy-policy-container">
      <Row>
        <Col md={12}>
          <h1>Privacy Policy</h1>

          <div className="privacy-policy-section">
            <p>
              Bandlr is committed to protecting your privacy. This Privacy
              Policy explains how we handle personally identifiable information
              collected through the Bandlr website and mobile application
              ("App"). By using Bandlr, you accept the practices described in
              this Privacy Policy. Your privacy is important to us, and we
              ensure that all data you share is handled securely and
              transparently.
            </p>
          </div>

          <div className="privacy-policy-section">
            <h2>Why Do We Collect Personal Information?</h2>
            <p>
              In this Privacy Policy, "Personal Data" refers to information that
              can identify you directly or indirectly. Bandlr collects and
              processes Personal Data for the following reasons:
            </p>
            <ul>
              <li>To fulfill our contractual obligations to you as a user.</li>
              <li>
                To connect you with others for real-life hangouts or online
                group chats.
              </li>
              <li>
                To offer features like plan discovery, user suggestions,
                location-based meetups, and social interaction tools.
              </li>
              <li>To comply with legal obligations.</li>
              <li>
                To analyze your app usage and improve our service experience.
              </li>
            </ul>

            <p>
              In some cases, we require your explicit consent, such as when:
            </p>
            <ul>
              <li>Sending newsletters or promotional messages.</li>
              <li>Using cookies and tracking technologies.</li>
              <li>Processing your profile, interests, bio, and photos.</li>
              <li>Accessing your geolocation.</li>
              <li>
                Displaying your account on Bandlr's homepage or marketing
                material (with your consent).
              </li>
            </ul>
            <p>
              You may withdraw your consent at any time, although past data
              usage based on prior consent remains lawful.
            </p>
          </div>

          <div className="privacy-policy-section">
            <h2>What Personal Data Do We Collect?</h2>
            <p>
              When you register for Bandlr, we collect and process the following
              data:
            </p>
            <ul>
              <li>
                Account Information: Name, email, date of birth, display photo,
                and bio.
              </li>
              <li>
                Login Data: You may sign up using Google or Apple login. In that
                case, we will process the data those platforms share with us,
                such as your name, email, and profile image.
              </li>
              <li>
                Device & Technical Data: IP address, browser type, OS, time
                zone, device ID, and login logs.
              </li>
              <li>
                Geolocation: With your consent, we collect and share approximate
                location (not more accurate than 0.5 km) to help you discover
                and connect with other nearby users.
              </li>
              <li>
                Photos: Profile pictures and other images you upload. These may
                be optimized for presentation. We may use automated tools to
                evaluate image quality or detect spam.
              </li>
              <li>
                Content: Messages in group chats, bios, and other content you
                share. Bandlr does not read private messages unless flagged for
                violating terms (e.g., abuse or spam).
              </li>
              <li>
                Customer Service Records: Any support interaction may be logged
                to improve our assistance.
              </li>
              <li>
                Invite Contacts: If you invite friends, we process the contact
                details you provide to send a message. These contacts are not
                stored beyond this purpose.
              </li>
            </ul>
          </div>

          <div className="privacy-policy-section">
            <h2>How We Use Your Data</h2>
            <p>We use your Personal Data to:</p>
            <ul>
              <li>Display your profile and connect you with other users.</li>
              <li>Facilitate matching for hangout plans.</li>
              <li>
                Send updates related to your account, chats, invites, and app
                activity.
              </li>
              <li>
                Conduct app performance analysis and improve our services.
              </li>
              <li>Prevent abuse or violations of our community guidelines.</li>
              <li>
                Show relevant notifications and suggestions if you've opted in.
              </li>
            </ul>

            <p>
              We never sell your Personal Data. We only share your data when:
            </p>
            <ul>
              <li>You choose to make your profile visible.</li>
              <li>Required by law or legal obligation.</li>
              <li>
                Needed for processing by verified service providers under
                confidentiality agreements.
              </li>
              <li>
                Necessary to enforce our terms or protect Bandlr, users, or the
                public.
              </li>
            </ul>
          </div>

          <div className="privacy-policy-section">
            <h2>Data Security</h2>
            <p>
              We take appropriate security measures to protect your Personal
              Data from unauthorized access or misuse, including:
            </p>
            <ul>
              <li>SSL encryption.</li>
              <li>Access controls based on employee roles.</li>
              <li>Password protection and secure storage.</li>
            </ul>
            <p>
              However, no method of data transmission over the internet is 100%
              secure. You acknowledge that any data you share is at your own
              risk.
            </p>
          </div>

          <div className="privacy-policy-section">
            <h2>Retention of Data</h2>
            <p>
              We retain your Personal Data for as long as necessary for the
              purposes stated above. If your account is inactive for over 10
              years, we may delete your data.
            </p>
            <p>Upon account deletion:</p>
            <ul>
              <li>
                Your data is removed after a safety retention window of up to 5
                years (for backup and fraud prevention).
              </li>
              <li>
                Your email and phone number may be retained for handling past
                transactions or payment issues.
              </li>
              <li>
                Non-personal, aggregate data (e.g., usage metrics) may be
                retained for internal reporting.
              </li>
            </ul>
          </div>

          <div className="privacy-policy-section">
            <h2>Data Hosting & Transfers</h2>
            <p>
              Your data may be stored on servers located outside your country of
              residence. In such cases, we ensure the data is handled securely
              and complies with applicable privacy laws.
            </p>
          </div>

          <div className="privacy-policy-section">
            <h2>Children's Privacy</h2>
            <p>
              Bandlr does not knowingly collect data from users under the age of
              18. If a minor has provided false information, their guardian can
              notify us at jay@bandlr.com, and we will promptly delete the
              associated data.
            </p>
          </div>

          <div className="privacy-policy-section">
            <h2>Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy periodically at our own
              discretion. If significant changes are made, you will be notified
              via a prompt in the app or via email. Continued use of Bandlr
              after changes indicates your acceptance of the revised policy.
            </p>
          </div>

          <div className="privacy-contact">
            <h2>Contact Us</h2>
            <p>Email: jay@bandlr.com</p>
            <p>
              For any questions, concerns, or reports of suspicious activity,
              please contact us.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicy;
